import { backdropClasses } from "@mui/material/Backdrop";
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    // Legacy react-bootstrap modals are pinned at 9998 (custom.css), so every MUI
    // overlay has to sit above them. Dialog, Popover, Menu and Autocomplete all
    // share the modal layer: DOM order then puts a dropdown, or a nested dialog,
    // above the dialog that opened it.
    zIndex: {
        modal: 9999,
        snackbar: 10000,
        tooltip: 10001,
    },
    palette: {
        primary: {
            main: "#ed6c02",
        },
        secondary: {
            main: "#1177F2",
        },
        tooltip: {
            main: "#000000",
        },
    },
    components: {
        // Safety net for a known MUI + react-transition-group + React 18 bug
        // (mui/material-ui#32286, #44906): a Dialog/Modal's exit transition can
        // fail to fire `onExited`, leaving the modal root mounted at opacity 0 —
        // invisible but swallowing every click. When that happens, let the stuck
        // (opacity: 0) modal ignore pointer events so the page stays interactive.
        MuiModal: {
            styleOverrides: {
                root: {
                    [`&:has(> .${backdropClasses.root}[style*="opacity: 0"])`]:
                        {
                            pointerEvents: "none",
                        },
                },
            },
        },
        MuiBackdrop: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    ...(!ownerState.invisible && {
                        backdropFilter: "blur(2px)",
                    }),
                    '&[style*="opacity: 0"]': {
                        pointerEvents: "none",
                    },
                }),
            },
        },
        // Dropdowns (Select, Menu, Autocomplete) are Popover-based and lock body
        // scroll by default, same as Dialog/Modal. Scroll lock should only apply
        // to actual modals, so opt dropdowns out here instead of per-component.
        // Scrollbar styling is global-only (App.css); dropdowns inherit it.
        MuiPopover: {
            defaultProps: {
                disableScrollLock: true,
            },
        },
        MuiMenu: {
            defaultProps: {
                disableScrollLock: true,
            },
        },
        MuiSwitch: {
            defaultProps: {
                color: "secondary",
            },
        },
        // Checkboxes use black for the primary (checked/indeterminate) state
        // rather than the orange palette.primary, matching SignalSight.
        MuiCheckbox: {
            defaultProps: {
                color: "primary",
            },
            styleOverrides: {
                colorPrimary: {
                    "&.Mui-checked, &.MuiCheckbox-indeterminate": {
                        color: "#000000",
                    },
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                color: "primary",
            },
        },
        // Always float the label into the outline notch so it stays visible and
        // the native placeholder shows in the empty state (MUI only reveals the
        // placeholder once the label is shrunk/focused).
        MuiInputLabel: {
            defaultProps: {
                shrink: true,
            },
        },
        MuiInput: {
            defaultProps: {
                input: {
                    color: "primary",
                },
            },
        },
        // option
        MuiSelect: {
            defaultProps: {
                color: "primary",
            },
            styleOverrides: {
                option: {
                    color: "primary",
                },
            },
        },
    },
});

export default theme;
